const uuidv4 = require('uuid/v4')


export const generateUUID = () => (
  uuidv4()
)
